import { useNavigate, useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { useGet } from "../../Hooks/useFetch";
import { getddmmyyyyFormat } from "../../Helpers/Helper";
import { ViewIcon } from "../Icons";
import DataLoader from "../DataLoader";
import AlertMessage from "../AlertMessage";
import "react-native-get-random-values";
import { v4 as uuidv4 } from "uuid";

const ComVesselList = () => {
  const [res, err, isLoading, apiGet, abt] = useGet();
  useEffect(() => {
    apiGet("/api/fa/FaVessels");
  }, []);

  // console.log(res);

  return (
    <div className="comvessel-sub-container">
      <div className="comvessel-title-group">
        <h3 className="comvessel-title">Commercial Vessels</h3>
      </div>

      {!isLoading ? (
        !err ? (
          res?.length === 0 ? (
            <AlertMessage
              message="No Commercial Vessels"
              level="info"
              closeEvt="false"
              mt="0"
              mb="0"
            />
          ) : (
            res?.map((f) => (
              <>
                <div className="row" key={uuidv4()}>
                  <div className="col-md-3">
                    <div className="comvessel-input-group">
                      <label htmlFor="AmsaUVI">AMSA UVI</label>
                      <div className="comvesselInfoField">{f?.favAmsaUvi}</div>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="comvessel-input-group">
                      <label htmlFor="VesselName">Vessel Name</label>
                      <div className="comvesselInfoField">{f?.favVesName}</div>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="comvessel-input-group">
                      <label htmlFor="">Date Expiry</label>
                      <div className="comvesselInfoField">
                        {getddmmyyyyFormat(f?.favExpiryDate?.split("T")[0])}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="comvessel-input-group">
                      <label htmlFor="Action">Action</label>
                      <div className="icon-group">
                        <ViewIcon
                          url={"/comvessel/comvesseldetails/" + f?.favSysId}
                          HoverCaption="View Commercial Vessel Details"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ))
          )
        ) : (
          <AlertMessage message={err} />
        )
      ) : (
        <div className="dataLoader-container">
          <DataLoader isLoading={isLoading} />
        </div>
      )}
    </div>
  );
};

export default ComVesselList;
